import { render, staticRenderFns } from "./OxygenVideoInput.vue?vue&type=template&id=97cfc5b4&scoped=true&"
import script from "./OxygenVideoInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenVideoInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cfc5b4",
  null
  
)

export default component.exports